import { SVGProps } from 'react'

// Line icons in the text's colour (stroke currentColor), for marks and small
// actions that used to be typed as symbols or emoji (✓ ✓✓ ⇄ 🙂 📄 📥): a glyph
// drew in each platform's own font and emoji set, and in the dark theme an
// emoji kept its own colours. Hidden from screen readers by default - the
// text beside an icon, or the name of its button, says what it means.
const line = (paths: string[], strokeWidth = 2) => {
  const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
  return Icon
}

export const CheckMarkIcon = line(['M5 12.5l4.5 4.5L19 7.5'], 2.4)
// read: two marks
export const DoubleCheckIcon = line(['M1.5 12.5L6 17l9.5-9.5', 'M11.5 16l1 1L22 7.5'], 2.2)
// compare: two opposite arrows
export const CompareIcon = line(['M4 8h15', 'M15 4l4 4-4 4', 'M20 16H5', 'M9 12l-4 4 4 4'])
export const SmileIcon = line([
  'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',
  'M8.5 14.5c.9 1.3 2 2 3.5 2s2.6-.7 3.5-2',
  'M9 9.5h.01',
  'M15 9.5h.01',
])
export const DocumentIcon = line([
  'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z',
  'M14 3v5h5',
])
export const DownloadIcon = line(['M12 4v11', 'M7 10l5 5 5-5', 'M5 20h14'])
export const ArrowDownLineIcon = line(['M12 5v14', 'M6 13l6 6 6-6'])
